import constants from "../constants.js";

import { 
  EnhancedPolicyRulesActionsPnrRemarksExclusionRemarks,
  EnhancedPolicyRulesActionsPnrRemarksStandardRemarks,
  EnhancedPolicyRulesActionsPnrRemarksStandardRemarksInfo,
  EnhancedPolicyRulesActionsPnrRemarksHostCommands,
  EnhancedPolicyRulesActionsPnrRemarksHostCommandsInfo,
  EnhancedPolicyRulesActionsPnrRemarksPreTripApprovalRemarksExclusions,
  EnhancedPolicyRulesActionsPnrRemarksPreTripApprovalRemarks,
  EnhancedPolicyRulesActionsPnrRemarksGuestTravellerRemarksExclusions,
  EnhancedPolicyRulesActionsPnrRemarksGuestTravellerRemarks,
  EnhancedPolicyRulesActionsPnrRemarksApprovalRemarksExclusions,
  EnhancedPolicyRulesActionsPnrRemarksApprovalRemarks,
  EnhancedPolicyRulesActionsPnrRemarksDeclinedRemarksExclusions,
  EnhancedPolicyRulesActionsPnrRemarksDeclinedRemarks,
  EnhancedPolicyRulesActionsPnrRemarksDeclinedRemarksNonRefundableExclusions,
  EnhancedPolicyRulesActionsPnrRemarksDeclinedRemarksNonRefundableRemarks,
  EnhancedPolicyRulesActionsPnrRemarksExpiredRemarksExclusions,
  EnhancedPolicyRulesActionsPnrRemarksExpiredRemarks,
  EnhancedPolicyRulesActionsPnrRemarksCancelRemarksExclusions,
  EnhancedPolicyRulesActionsPnrRemarksCancelRemarks,
  EnhancedPolicyRulesActionsPnrRemarksModifyRemarksExclusions,
  EnhancedPolicyRulesActionsPnrRemarksModifyRemarksRemarks,
  EnhancedPolicyRulesActionsPnrRemarksUserHoldRemarksExclusions,
  EnhancedPolicyRulesActionsPnrRemarksUserHoldRemarks,
  EnhancedPolicyRulesActionsPnrRemarksExpiredUserHoldRemarksExclusions,
  EnhancedPolicyRulesActionsPnrRemarksExpiredUserHoldRemarks,
  EnhancedPolicyRulesActionsPnrRemarksConfirmedUserHoldRemarksExclusions,
  EnhancedPolicyRulesActionsPnrRemarksConfirmedUserHoldRemarks,
  EnhancedPolicyRulesActionsPnrRemarksFinisherBookingRemarksExclusions,
  EnhancedPolicyRulesActionsPnrRemarksFinishBookingRemarksRemarks,
  EnhancedPolicyRulesActionsPnrRemarksGdsRemarksGrid,
  EnhancedPolicyRulesActionsPnrRemarksGdsRemarksItem,
  EnhancedPolicyRulesActionsPnrRemarksGdsRemarksName,
  EnhancedPolicyRulesActionsPnrRemarksGdsRemarksFinishingRemarksExclusions,
  EnhancedPolicyRulesActionsPnrRemarksGdsRemarksFinishingRemarks,
  EnhancedPolicyRulesActionsPnrRemarksGdsRemarksSeatRemarks,
  EnhancedPolicyRulesActionsPnrRemarksGdsRemarksAncillaryRemarks
} from './enhancedPolicyRulesPnrRemarks';

import { 
  EnhancedPolicyRulesActionsPnrExtraActionProfileMovesItem,
  EnhancedPolicyRulesActionsPnrExtraActionQueuePlacementsItem,
  EnhancedPolicyRulesActionsPnrExtraActionEmailBooking,
  EnhancedPolicyRulesActionsPnrExtraActionEmailModification,
  EnhancedPolicyRulesActionsPnrExtraActionEmailCancel,
  EnhancedPolicyRulesActionsPnrExtraActionEmaiApproval,
  EnhancedPolicyRulesActionsPnrExtraActionEmailError,
  EnhancedPolicyRulesActionsPnrExtraActionProfileMoveProfileId,
  EnhancedPolicyRulesActionsPnrExtraActionProfileMoveProfileTypeCode,
  EnhancedPolicyRulesActionsPnrExtraActionProfileMovePcc,
  EnhancedPolicyRulesActionsPnrExtraActionProfileMovePnrBuilder,
  EnhancedPolicyRulesActionsPnrExtraActionProfileMovesGrid,
  EnhancedPolicyRulesActionsPnrExtraActionQueuePlacementsQueueActionType,
  EnhancedPolicyRulesActionsPnrExtraActionQueuePlacementsNumber,
  EnhancedPolicyRulesActionsPnrExtraActionQueuePlacementsPcc,
  EnhancedPolicyRulesActionsPnrExtraActionQueuePlacementsPrefatoryInstructionCode,
  EnhancedPolicyRulesActionsPnrExtraActionQueuePlacementsGrid
} from './enhancedPolicyRulesPnrExtraAction';

import {
  EnhancedPolicyRulesConditionsCollectionOperationTypeFn,
  EnhancedPolicyRulesConditionsIsExpressionFn,
  EnhancedPolicyRulesConditionsIsCollectionFn,
  EnhancedPolicyRulesConditionsOperatorTypeFn,
  EnhancedPolicyRulesConditionsSourceFormatFn,
  EnhancedPolicyRulesConditionsConditionTypeFn,
  EnhancedPolicyRulesConditionsValuesFn,
  EnhancedPolicyRulesConditionsItemFn,
  EnhancedPolicyRulesConditionsFn
} from '../components/forms/conditions.js';
 
import { 
EnhancedPolicyFlightModificationSettingItem,
EnhancedPolicyFlightSearchConfigurationItem,
EnhancedPolicyRulesActionsPolicySettingsItem
} from './enhancedPolicyRulesPolicySettings';

import {
  EnhancedPolicyRulesActionsLimitPassengerItem,
  EnhancedPolicyRulesLimitPassengerPolicyUdidConfigurationsItem
} from './enhancedPolicyRulesLimitPassenger.js'

// --- START Debtors

const EnhancedPolicyRulesDebtorsDebtorIdentifier = {
  displayName: "Debtor Identifier",
  dataAt: "Debtors.$EnhancedPolicyRulesDebtorsItem.DebtorIdentifier",
  displayAs: constants.DISPLAY_AS.TEXT_INPUT,
};

const EnhancedPolicyRulesDebtorsPolicyCodes = {
  displayName: "Policy Codes",
  dataAt: "Debtors.$EnhancedPolicyRulesDebtorsItem.PolicyCodes",
  displayAs: constants.DISPLAY_AS.TAG_INPUT,
};

const EnhancedPolicyRulesDebtorsCountryCodes = {
  displayName: "Debtor Country Codes",
  dataAt: "Debtors.$EnhancedPolicyRulesDebtorsItem.CountryCodes",
  displayAs: constants.DISPLAY_AS.TAG_INPUT,
};

const EnhancedPolicyRulesDebtorsItem = {
  displayName: "Debtors",
  dataAt: "Debtors.$EnhancedPolicyRulesDebtorsItem",
  displayAs: constants.DISPLAY_AS.RESOURCE,
  children: [
    EnhancedPolicyRulesDebtorsDebtorIdentifier,
    EnhancedPolicyRulesDebtorsPolicyCodes,
    EnhancedPolicyRulesDebtorsCountryCodes
  ],
  endpoint: "EnhancedPolicyRules",
  routeParamId: "enhancedPolicyRulesId",
  removeParamId: "EnhancedPolicyRulesDebtorsItem",
  canDelete: true,
};

const EnhancedPolicyRulesDebtors = {
  displayName: "Debtors",
  dataAt: "Debtors",
  displayAs: constants.DISPLAY_AS.GRID,
  canAddNew: true,
  gridItem: EnhancedPolicyRulesDebtorsItem,
  gridCols: [
    { name: "Debtor Identifier", key: "DebtorIdentifier" },
    { name: "Policy Codes", key: "PolicyCodes" },
    { name: "Debtor Country Codes", key: "CountryCodes" },
  ],
};

// --- END Debtors

// --- START Conditions

const EnhancedPolicyRulesConditionsCollectionOperationType = EnhancedPolicyRulesConditionsCollectionOperationTypeFn();
const EnhancedPolicyRulesConditionsIsExpression = EnhancedPolicyRulesConditionsIsExpressionFn();
const EnhancedPolicyRulesConditionsIsCollection = EnhancedPolicyRulesConditionsIsCollectionFn();
const EnhancedPolicyRulesConditionsOperatorType = EnhancedPolicyRulesConditionsOperatorTypeFn();
const EnhancedPolicyRulesConditionsSourceFormat = EnhancedPolicyRulesConditionsSourceFormatFn();
const EnhancedPolicyRulesConditionsConditionType = EnhancedPolicyRulesConditionsConditionTypeFn();
const EnhancedPolicyRulesConditionsValues =   EnhancedPolicyRulesConditionsValuesFn();
const EnhancedPolicyRulesConditionsItem = EnhancedPolicyRulesConditionsItemFn();
const EnhancedPolicyRulesConditions = EnhancedPolicyRulesConditionsFn();

// --- END Conditions

// --- START Actions

const EnhancedPolicyRulesActionsNewActionsItemType = {
  displayName: "Type",
  dataAt: "Actions.$EnhancedPolicyRulesNewActionsItem.Type",
  optionsAt: "ActionType",
  displayAs: constants.DISPLAY_AS.SELECT,
};

const EnhancedPolicyRulesActionsDisplayMessageType = {
  displayName: "Type",
  disabled: true,
  dataAt: "Actions.$EnhancedPolicyRulesActionsDisplayMessageItem.Type",
  displayAs: constants.DISPLAY_AS.TEXT_INPUT,
};

const EnhancedPolicyRulesActionsDisplayTitle = {
  displayName: "Title",
  dataAt:
    "Actions.$EnhancedPolicyRulesActionsDisplayMessageItem.DisplayMessage.Title",
  displayAs: constants.DISPLAY_AS.TEXT_INPUT,
  validationRegex: "^.{0,70}$",
  validationMessage: "The maximum length for the title is 70 characters",
};

const EnhancedPolicyRulesActionsDisplayMessage = {
  displayName: "Message",
  dataAt:
    "Actions.$EnhancedPolicyRulesActionsDisplayMessageItem.DisplayMessage.Message",
  displayAs: constants.DISPLAY_AS.TEXT_AREA,
};

const EnhancedPolicyRulesActionsMessagePlacementType = {
  displayName: "Message Placement Type",
  dataAt:
    "Actions.$EnhancedPolicyRulesActionsDisplayMessageItem.DisplayMessage.MessagePlacementType",
  displayAs: constants.DISPLAY_AS.SELECT,
  optionsAt: "MessagePlacementType",
};

const EnhancedPolicyRulesActionsMessageSectorTypes = {
  displayName: "Message Sector Types",
  dataAt:
    "Actions.$EnhancedPolicyRulesActionsDisplayMessageItem.DisplayMessage.MessageSectorTypes",
  optionsAt: "SectorType",
  displayAs: constants.DISPLAY_AS.MULTI_SELECT,
};

const EnhancedPolicyRulesActionsForceCreditCardType = {
  displayName: "Type",
  disabled: true,
  dataAt: "Actions.$EnhancedPolicyRulesActionsForceCreditCardItem.Type",
  displayAs: constants.DISPLAY_AS.TEXT_INPUT,
};

const EnhancedPolicyRulesActionsForceCreditCardCardApplicationType = {
  displayName: "CardApplicationType",
  dataAt:
    "Actions.$EnhancedPolicyRulesActionsForceCreditCardItem.ForceCreditCard.CardApplicationType",
  displayAs: constants.DISPLAY_AS.SELECT,
  optionsAt: "CardApplicationType",
};

const EnhancedPolicyRulesActionsForceCreditCardCardIdentifier = {
  displayName: "CardIdentifier",
  dataAt:
    "Actions.$EnhancedPolicyRulesActionsForceCreditCardItem.ForceCreditCard.CardIdentifier",
  displayAs: constants.DISPLAY_AS.O_DATA_SELECT,
  endpoint: "CreditCards",
  searchType: "Title",
  expression: "contains",
  searchAllNo: true,
};

const EnhancedPolicyRulesActionsForceCreditCardCardSectorTypes = {
  displayName: "CardSectorTypes",
  dataAt:
    "Actions.$EnhancedPolicyRulesActionsForceCreditCardItem.ForceCreditCard.CardSectorTypes",
  optionsAt: "CardSectorType",
  displayAs: constants.DISPLAY_AS.MULTI_SELECT,
};

const EnhancedPolicyRulesActionsSectorTypes = {
  displayName: "Sector Type",
  dataAt: 
    "Actions.$EnhancedPolicyRulesActionsDisplayMessageItem.SectorType",
  optionsAt: "SectorType",
  displayAs: constants.DISPLAY_AS.SELECT,
};
const EnhancedPolicyRulesActionsPolicyViolationListId = {
  displayName: "ListId",
  dataAt: "Actions.$EnhancedPolicyRulesActionsDisplayMessageItem.PolicyViolation.ListId",
  displayAs: constants.DISPLAY_AS.TEXT_INPUT,
  html: "Company Reference ListId to pull option values to choose from."
};
const EnhancedPolicyRulesActionsPolicyViolationRemarkFormat = {
  displayName: "RemarkFormat",
  dataAt: "Actions.$EnhancedPolicyRulesActionsDisplayMessageItem.PolicyViolation.RemarkFormat",
  displayAs: constants.DISPLAY_AS.TEXT_INPUT,
  html: "Smart.Format used to write remark to booking.<br/>Exmple: .S*UD110 VIOLATION CODE {Value}-{Flight.FlightNumber}<br/><i>Properties</i>" 
  + "<ul><li>ValueDescription</li><li>Value</li><li>Flight</li></ul>"
};

const EnhancedPolicyRulesActionsSetOutOfPolicyItem = {
  displayName: "Actions Set Out Of Policy",
  dataAt: "Actions.$EnhancedPolicyRulesActionsDisplayMessageItem",
  displayAs: constants.DISPLAY_AS.RESOURCE,
  children: [
    EnhancedPolicyRulesActionsDisplayMessageType,
    EnhancedPolicyRulesActionsSectorTypes,
    EnhancedPolicyRulesActionsDisplayMessage,
    EnhancedPolicyRulesActionsPolicyViolationListId,
    EnhancedPolicyRulesActionsPolicyViolationRemarkFormat
  ],
  endpoint: "EnhancedPolicyRules",
  routeParamId: "enhancedPolicyRulesId",
  removeParamId: "EnhancedPolicyRulesActionsDisplayMessageItem",
  canDelete: true,
};

const EnhancedPolicyRulesActionsDisplayMessageItem = {
  displayName: "Actions Display Message",
  dataAt: "Actions.$EnhancedPolicyRulesActionsDisplayMessageItem",
  displayAs: constants.DISPLAY_AS.RESOURCE,
  children: [
    EnhancedPolicyRulesActionsDisplayMessageType,
    EnhancedPolicyRulesActionsDisplayTitle,
    EnhancedPolicyRulesActionsDisplayMessage,
    EnhancedPolicyRulesActionsMessagePlacementType,
    EnhancedPolicyRulesActionsMessageSectorTypes
  ],
  endpoint: "EnhancedPolicyRules",
  routeParamId: "enhancedPolicyRulesId",
  removeParamId: "EnhancedPolicyRulesActionsDisplayMessageItem",
  canDelete: true,
};

const EnhancedPolicyRulesActionsMessagePopupItem = {
  displayName: "Actions Message Popup",
  dataAt: "Actions.$EnhancedPolicyRulesActionsDisplayMessageItem",
  displayAs: constants.DISPLAY_AS.RESOURCE,
  children: [
    EnhancedPolicyRulesActionsDisplayMessageType,
    EnhancedPolicyRulesActionsDisplayTitle,
    EnhancedPolicyRulesActionsDisplayMessage,
    EnhancedPolicyRulesActionsMessageSectorTypes
  ],
  endpoint: "EnhancedPolicyRules",
  routeParamId: "enhancedPolicyRulesId",
  removeParamId: "EnhancedPolicyRulesActionsDisplayMessageItem",
  canDelete: true,
};

const EnhancedPolicyRulesActionsPolicyMessageItem = {
  displayName: "Actions Display Message",
  dataAt: "Actions.$EnhancedPolicyRulesActionsDisplayMessageItem",
  displayAs: constants.DISPLAY_AS.RESOURCE,
  children: [
    EnhancedPolicyRulesActionsDisplayMessageType,
    EnhancedPolicyRulesActionsSectorTypes,
    EnhancedPolicyRulesActionsDisplayMessage
  ],
  endpoint: "EnhancedPolicyRules",
  routeParamId: "enhancedPolicyRulesId",
  removeParamId: "EnhancedPolicyRulesActionsDisplayMessageItem",
  canDelete: true,
};

const EnhancedPolicyRulesActionsPolicyItem = {
  displayName: "Policy Item",
  dataAt: "Actions.$EnhancedPolicyRulesActionsDisplayMessageItem",
  displayAs: constants.DISPLAY_AS.RESOURCE,
  children: [
    EnhancedPolicyRulesActionsDisplayMessageType,
    EnhancedPolicyRulesActionsSectorTypes
  ],
  endpoint: "EnhancedPolicyRules",
  routeParamId: "enhancedPolicyRulesId",
  removeParamId: "EnhancedPolicyRulesActionsDisplayMessageItem",
  canDelete: true,
};

const EnhancedPolicyRulesActionsPnrRemarksItem = {
  displayName: "Actions Pnr Remarks",
  dataAt: "Actions.$EnhancedPolicyRulesActionsPnrRemarksItem",
  displayAs: constants.DISPLAY_AS.RESOURCE,
  children: [
    EnhancedPolicyRulesActionsPnrRemarksExclusionRemarks,
    EnhancedPolicyRulesActionsPnrRemarksStandardRemarks,
    EnhancedPolicyRulesActionsPnrRemarksStandardRemarksInfo,
    EnhancedPolicyRulesActionsPnrRemarksHostCommands,
    EnhancedPolicyRulesActionsPnrRemarksHostCommandsInfo,
    EnhancedPolicyRulesActionsPnrRemarksPreTripApprovalRemarksExclusions,
    EnhancedPolicyRulesActionsPnrRemarksPreTripApprovalRemarks,
    EnhancedPolicyRulesActionsPnrRemarksGuestTravellerRemarksExclusions,
    EnhancedPolicyRulesActionsPnrRemarksGuestTravellerRemarks,
    EnhancedPolicyRulesActionsPnrRemarksApprovalRemarksExclusions,
    EnhancedPolicyRulesActionsPnrRemarksApprovalRemarks,
    EnhancedPolicyRulesActionsPnrRemarksDeclinedRemarksExclusions,
    EnhancedPolicyRulesActionsPnrRemarksDeclinedRemarks,
    EnhancedPolicyRulesActionsPnrRemarksDeclinedRemarksNonRefundableExclusions,
    EnhancedPolicyRulesActionsPnrRemarksDeclinedRemarksNonRefundableRemarks,
    EnhancedPolicyRulesActionsPnrRemarksExpiredRemarksExclusions,
    EnhancedPolicyRulesActionsPnrRemarksExpiredRemarks,
    EnhancedPolicyRulesActionsPnrRemarksCancelRemarksExclusions,
    EnhancedPolicyRulesActionsPnrRemarksCancelRemarks,
    EnhancedPolicyRulesActionsPnrRemarksModifyRemarksExclusions,
    EnhancedPolicyRulesActionsPnrRemarksModifyRemarksRemarks,
    EnhancedPolicyRulesActionsPnrRemarksUserHoldRemarksExclusions,
    EnhancedPolicyRulesActionsPnrRemarksUserHoldRemarks,
    EnhancedPolicyRulesActionsPnrRemarksExpiredUserHoldRemarksExclusions,
    EnhancedPolicyRulesActionsPnrRemarksExpiredUserHoldRemarks,
    EnhancedPolicyRulesActionsPnrRemarksConfirmedUserHoldRemarksExclusions,
    EnhancedPolicyRulesActionsPnrRemarksConfirmedUserHoldRemarks,
    EnhancedPolicyRulesActionsPnrRemarksFinisherBookingRemarksExclusions,
    EnhancedPolicyRulesActionsPnrRemarksFinishBookingRemarksRemarks,
    EnhancedPolicyRulesActionsPnrRemarksGdsRemarksGrid
  ],
  endpoint: "EnhancedPolicyRules",
  routeParamId: "enhancedPolicyRulesId",
  removeParamId: "EnhancedPolicyRulesActionsPnrRemarksItem",
  canDelete: true,
};

const EnhancedPolicyRulesActionsPnrExtraActionItem = {
  displayName: "Actions Pnr Remarks",
  dataAt: "Actions.$EnhancedPolicyRulesActionsPnrExtraActionItem",
  displayAs: constants.DISPLAY_AS.RESOURCE,
  children: [
    EnhancedPolicyRulesActionsPnrExtraActionEmailBooking,
    EnhancedPolicyRulesActionsPnrExtraActionEmailModification,
    EnhancedPolicyRulesActionsPnrExtraActionEmailCancel,
    EnhancedPolicyRulesActionsPnrExtraActionEmaiApproval,
    EnhancedPolicyRulesActionsPnrExtraActionEmailError,
    EnhancedPolicyRulesActionsPnrExtraActionProfileMovesGrid,
    EnhancedPolicyRulesActionsPnrExtraActionQueuePlacementsGrid
  ],
  endpoint: "EnhancedPolicyRules",
  routeParamId: "enhancedPolicyRulesId",
  removeParamId: "EnhancedPolicyRulesActionsPnrExtraActionItem",
  canDelete: true,
};

const EnhancedPolicyRulesActionsCardMatchingItemType = {
  displayName: "Card Type",
  dataAt: "Actions.$EnhancedPolicyRulesActionsForceCreditCardItem.ForceCreditCard.CreditCardMatches.$CreditCardMatching.Type",
  displayAs: constants.DISPLAY_AS.TEXT_INPUT,
  validationRegex: "^(?:(?:undefined|null|)$|[A-Z]{2})$",
  validationMessage: "Please enter only 2 letters in capital letters here",
}

const EnhancedPolicyRulesActionsCardMatchingItemExpirationMonth = {
  displayName: "Expiration Month",
  dataAt: "Actions.$EnhancedPolicyRulesActionsForceCreditCardItem.ForceCreditCard.CreditCardMatches.$CreditCardMatching.ExpirationMonth",
  displayAs: constants.DISPLAY_AS.TEXT_INPUT,
  validationRegex: "^(?:(?:undefined|null|)$|0[1-9]|1[0-2])$",
  validationMessage: "Please enter only 2 digits and a number lower than 12 here",
}

const EnhancedPolicyRulesActionsCardMatchingItemExpirationYear = {
  displayName: "Expiration Year",
  dataAt: "Actions.$EnhancedPolicyRulesActionsForceCreditCardItem.ForceCreditCard.CreditCardMatches.$CreditCardMatching.ExpirationYear",
  displayAs: constants.DISPLAY_AS.TEXT_INPUT,
  validationRegex: "^\\d{4}$|undefined|null|^$",
  validationMessage: "Please enter only 4 digits here",
}

const EnhancedPolicyRulesActionsCardMatchingItemCreditNumberLast4 = {
  displayName: "Last Four Credit Card Digits",
  dataAt: "Actions.$EnhancedPolicyRulesActionsForceCreditCardItem.ForceCreditCard.CreditCardMatches.$CreditCardMatching.CreditNumberLast4",
  displayAs: constants.DISPLAY_AS.TEXT_INPUT,
  validationRegex: "^\\d{0,4}$|undefined|null|^$",
  validationMessage: "Please enter only 4 digits here",
}

const EnhancedPolicyRulesActionsCardMatchingItemCreditNumberFirst4 = {
  displayName: "First Four Credit Card Digits",
  dataAt: "Actions.$EnhancedPolicyRulesActionsForceCreditCardItem.ForceCreditCard.CreditCardMatches.$CreditCardMatching.CreditNumberFirst4",
  displayAs: constants.DISPLAY_AS.TEXT_INPUT,
  validationRegex: "^\\d{0,4}$|undefined|null|^$",
  validationMessage: "Please enter only 4 digits here",
}

const EnhancedPolicyRulesActionsForceCreditCardCreditCardMatchingItem = {
  displayName: "Credit Card Matching",
  dataAt: "Actions.$EnhancedPolicyRulesActionsForceCreditCardItem.ForceCreditCard.CreditCardMatches.$CreditCardMatching",
  displayAs: constants.DISPLAY_AS.RESOURCE,
  children: [
    EnhancedPolicyRulesActionsCardMatchingItemCreditNumberFirst4,
    EnhancedPolicyRulesActionsCardMatchingItemCreditNumberLast4,
    EnhancedPolicyRulesActionsCardMatchingItemExpirationYear,
    EnhancedPolicyRulesActionsCardMatchingItemExpirationMonth,
    EnhancedPolicyRulesActionsCardMatchingItemType
  ],
  endpoint: "EnhancedPolicyRules",
  routeParamId: "enhancedPolicyRulesId",
  removeParamId: "CreditCardMatching",
  validateAtLeastOneHasValueSet: "true",
  canDelete: true
};

const EnhancedPolicyRulesActionsForceCreditCardCreditCardMatching = {
  rootNode: true,
  displayName: "Credit Card Matching",
  dataAt: "Actions.$EnhancedPolicyRulesActionsForceCreditCardItem.ForceCreditCard.CreditCardMatches",
  displayAs: constants.DISPLAY_AS.GRID,
  canAddNew: true,
  gridItem: EnhancedPolicyRulesActionsForceCreditCardCreditCardMatchingItem,
  gridCols: [
    { name: "First Four Credit Card Digits", key: "CreditNumberFirst4" },
    { name: "Last Four Credit Card Digits", key: "CreditNumberLast4" },
    { name: "Expiration Year", key: "ExpirationYear" },
    { name: "Expiration Month", key: "ExpirationMonth" },
    { name: "Card Type", key: "Type" },
  ],
};

const EnhancedPolicyRulesActionsForceCreditCardItem = {
  displayName: "Actions Force Credit Card",
  dataAt: "Actions.$EnhancedPolicyRulesActionsForceCreditCardItem",
  displayAs: constants.DISPLAY_AS.RESOURCE,
  children: [
    EnhancedPolicyRulesActionsForceCreditCardType,
    EnhancedPolicyRulesActionsForceCreditCardCardApplicationType,
    EnhancedPolicyRulesActionsForceCreditCardCardIdentifier,
    EnhancedPolicyRulesActionsForceCreditCardCardSectorTypes,
    EnhancedPolicyRulesActionsForceCreditCardCreditCardMatching
  ],
  endpoint: "EnhancedPolicyRules",
  routeParamId: "enhancedPolicyRulesId",
  removeParamId: "EnhancedPolicyRulesActionsForceCreditCardItem",
  canDelete: true,
};

const EnhancedPolicyRulesNewActionsItem = {
  displayName: "Actions",
  dataAt: "Actions.$EnhancedPolicyRulesNewActionsItem",
  displayAs: constants.DISPLAY_AS.RESOURCE,
  children: [EnhancedPolicyRulesActionsNewActionsItemType],
  endpoint: "EnhancedPolicyRules",
  routeParamId: "enhancedPolicyRulesId",
  removeParamId: "EnhancedPolicyRulesNewActionsItem",
  canDelete: true,
  showAddNewOnOpen: true, 
  addNewRequiredField: "Actions.$EnhancedPolicyRulesNewActionsItem.Type",
  continueEditPath: getEnhancePolicyPath
};

const EnhancedPolicyRulesActions = {
  displayName: "Actions",
  dataAt: "Actions",
  displayAs: constants.DISPLAY_AS.GRID,
  canAddNew: true,
  pathSwitcher: enhancedPolicyActionRoute,
  gridItem: EnhancedPolicyRulesNewActionsItem,
  gridCols: [
    { name: "Type", key: "Type" },
    {
      name: "Info",
      key: "ActionInfo",
    },
  ],
};

// --- END Actions

const EnhancedPolicyRulesName = {
  displayName: "Name",
  dataAt: "Name",
  displayAs: constants.DISPLAY_AS.TEXT_INPUT,
  required: true,
};

const EnhancedPolicyRulesIsEnabled = {
  displayName: "Is Enabled",
  dataAt: "IsEnabled",
  displayAs: constants.DISPLAY_AS.BOOLEAN,
};

const EnhancedPolicyRulesEditResource = {
  displayName: "Enhanced Policy Rules",
  iconClass: "fa-gear",
  dataAt: "",
  displayAs: constants.DISPLAY_AS.RESOURCE,
  children: [
    EnhancedPolicyRulesName,
    EnhancedPolicyRulesIsEnabled,
    EnhancedPolicyRulesActions,
    EnhancedPolicyRulesConditions,
    EnhancedPolicyRulesDebtors,
  ],
  showBack: false, // Show the Back button. This will hide the other buttons in lbaResource.
  endpoint: "EnhancedPolicyRules",
  routeParamId: "enhancedPolicyRulesId",
  removeParamId: "enhancedPolicyRulesId",
  canDelete: true,
  deleteOnBackend: true,
};

const EnhancedPolicyRulesAddResource = {
  displayAs: constants.DISPLAY_AS.ADD_GRID_RESOURCE,
  displayName: "Enhanced Policy Rules",
  data: {
    Id: "",
    Name: "",
  },
  dataAt: "",
  children: [EnhancedPolicyRulesName],
  endpoint: "EnhancedPolicyRules",
};

const EnhancedPolicyRulesGrid = {
  canAddNew: true,
  canCopyResource: true,
  displayName: "Enhanced Policy Rules",
  displayAs: constants.DISPLAY_AS.PAGING_GRID,
  gridItem: EnhancedPolicyRulesEditResource,
  gridAdd: EnhancedPolicyRulesAddResource,
  gridCols: [
    { name: "Name", field: "Name" },
    { name: "Debtors", field: "DebtorItems" },
    { name: "Actions", field: "ActionItems" },
    { name: "Enabled", field: "IsEnabled" },
    { name: "ModifiedOn", field: "ModifiedOn",cellFilter: 'dateDisplay',width: '165' },
    
  ],
  endpoint: "EnhancedPolicyRules",
};

const EnhancedPolicyRules = {
  rootNode: true,
  iconClass: "fa-gear",
  displayName: "Enhanced Policy Rules",
  showTitle: false,
  displayAs: constants.DISPLAY_AS.GROUP,
  children: [EnhancedPolicyRulesGrid],
};
export function enhancedPolicyActionRoute(props) {
  switch (props.Type) {
    case "ForceCreditCard":
      return 'actions/force-credit-card';
    case "DisplayMessage": 
      return 'actions/display-message';
    case "ShowButNotAllow":
      return 'actions/policy-message';  
    case "SetOutOfPolicy":
      return 'actions/set-out-of-policy'; 
    case "MessagePopup":
      return 'actions/message-popup'; 
    case "SetInPolicy":
    case "ExcludeFromLLF":
    case "ExcludeFare":
      return 'actions/policy';
    case "PnrRemarks":
      return 'actions/pnr-remarks';
    case "PnrExtraAction":
      return 'actions/pnr-extra-action';
    case "PolicySettings":
      return 'actions/policy-settings';
    case "LimitPassengerPolicy":
      return 'actions/limit-passenger-policy'
    default:
      return 'actions';
  }
};

export function getEnhancePolicyPath(itemId,index,activeItem){
  let actionItem = activeItem.Actions[index];
  let displayNamePathReady = enhancedPolicyActionRoute(actionItem)
  return'/enhanced-policy-rules/' + itemId + '/info/' + displayNamePathReady + '/' + index;
}

export default {
  EnhancedPolicyRulesDebtors,
  EnhancedPolicyRulesDebtorsItem,
  EnhancedPolicyRulesDebtorsDebtorIdentifier,
  EnhancedPolicyRulesDebtorsPolicyCodes,
  EnhancedPolicyRulesDebtorsCountryCodes,

  EnhancedPolicyRulesConditionsCollectionOperationType,
  EnhancedPolicyRulesConditionsIsExpression,
  EnhancedPolicyRulesConditionsIsCollection,
  EnhancedPolicyRulesConditionsOperatorType,
  EnhancedPolicyRulesConditionsSourceFormat,
  EnhancedPolicyRulesConditionsConditionType,
  EnhancedPolicyRulesConditionsValues,
  EnhancedPolicyRulesConditions,
  EnhancedPolicyRulesConditionsItem,

  EnhancedPolicyRulesActionsDisplayMessageType,
  EnhancedPolicyRulesActionsForceCreditCardType,
  EnhancedPolicyRulesActionsDisplayTitle,
  EnhancedPolicyRulesActionsDisplayMessage,
  EnhancedPolicyRulesActionsMessagePlacementType,
  EnhancedPolicyRulesActionsMessageSectorTypes,
  EnhancedPolicyRulesActionsForceCreditCardCardApplicationType,
  EnhancedPolicyRulesActionsForceCreditCardCardIdentifier,
  EnhancedPolicyRulesActionsForceCreditCardCardSectorTypes,
  EnhancedPolicyRulesActionsForceCreditCardItem,
  EnhancedPolicyRulesActionsDisplayMessageItem,
  EnhancedPolicyRulesActionsPolicyMessageItem,
  EnhancedPolicyRulesActionsPolicyItem,
  EnhancedPolicyRulesActionsPnrRemarksItem,
  EnhancedPolicyRulesActionsNewActionsItemType,
  EnhancedPolicyRulesNewActionsItem,
  EnhancedPolicyRulesActions,
  EnhancedPolicyRulesActionsForceCreditCardCreditCardMatching,
  EnhancedPolicyRulesActionsForceCreditCardCreditCardMatchingItem,
  EnhancedPolicyRulesActionsCardMatchingItemCreditNumberFirst4,
  EnhancedPolicyRulesActionsCardMatchingItemCreditNumberLast4,
  EnhancedPolicyRulesActionsCardMatchingItemExpirationYear,
  EnhancedPolicyRulesActionsCardMatchingItemExpirationMonth,
  EnhancedPolicyRulesActionsCardMatchingItemType,
  EnhancedPolicyRules,
  EnhancedPolicyRulesGrid,
  EnhancedPolicyRulesAddResource,
  EnhancedPolicyRulesEditResource,
  EnhancedPolicyRulesName,
  EnhancedPolicyRulesIsEnabled,
  
  EnhancedPolicyRulesActionsMessagePopupItem,
  EnhancedPolicyRulesActionsSetOutOfPolicyItem,
  EnhancedPolicyRulesActionsPolicyViolationListId,
  EnhancedPolicyRulesActionsPolicyViolationRemarkFormat,
  EnhancedPolicyRulesActionsPnrRemarksGdsRemarksItem,
  EnhancedPolicyRulesActionsPnrRemarksGdsRemarksName,
  EnhancedPolicyRulesActionsPnrRemarksGdsRemarksFinishingRemarksExclusions,
  EnhancedPolicyRulesActionsPnrRemarksGdsRemarksFinishingRemarks,
  EnhancedPolicyRulesActionsPnrRemarksGdsRemarksSeatRemarks,
  EnhancedPolicyRulesActionsPnrRemarksGdsRemarksAncillaryRemarks,

  EnhancedPolicyRulesActionsPnrExtraActionItem,
  EnhancedPolicyRulesActionsPnrExtraActionProfileMovesItem,
  EnhancedPolicyRulesActionsPnrExtraActionQueuePlacementsItem,
  EnhancedPolicyRulesActionsPnrExtraActionEmailBooking,
  EnhancedPolicyRulesActionsPnrExtraActionEmailModification,
  EnhancedPolicyRulesActionsPnrExtraActionEmailCancel,
  EnhancedPolicyRulesActionsPnrExtraActionEmaiApproval,
  EnhancedPolicyRulesActionsPnrExtraActionEmailError,
  EnhancedPolicyRulesActionsPnrExtraActionProfileMoveProfileId,
  EnhancedPolicyRulesActionsPnrExtraActionProfileMoveProfileTypeCode,
  EnhancedPolicyRulesActionsPnrExtraActionProfileMovePcc,
  EnhancedPolicyRulesActionsPnrExtraActionProfileMovePnrBuilder,
  EnhancedPolicyRulesActionsPnrExtraActionProfileMovesGrid,
  EnhancedPolicyRulesActionsPnrExtraActionQueuePlacementsQueueActionType,
  EnhancedPolicyRulesActionsPnrExtraActionQueuePlacementsNumber,
  EnhancedPolicyRulesActionsPnrExtraActionQueuePlacementsPcc,
  EnhancedPolicyRulesActionsPnrExtraActionQueuePlacementsPrefatoryInstructionCode,
  EnhancedPolicyRulesActionsPnrExtraActionQueuePlacementsGrid,

  EnhancedPolicyFlightModificationSettingItem,
  EnhancedPolicyRulesActionsPolicySettingsItem,
  EnhancedPolicyFlightSearchConfigurationItem,

  EnhancedPolicyRulesActionsLimitPassengerItem,
  EnhancedPolicyRulesLimitPassengerPolicyUdidConfigurationsItem
};



// WEBPACK FOOTER //
// ./src/config/fields/enhancedPolicyRules.js